import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DemonstrativosFaturasService {

  constructor(private readonly http: HttpClient) {
  }

  getAllFaturas(idEmpresa: string, cnpjEmpresa: string, tipoBusca: string, dataInicial: string, dataFinal: string) {

    let queryParams = new HttpParams();

    queryParams = queryParams.append('idEmpresa', idEmpresa);

    if (cnpjEmpresa) {
      queryParams = queryParams.append('cnpj', cnpjEmpresa);
    }

    queryParams = queryParams.append('tipoPesquisa', tipoBusca);

    if (dataInicial) {
      queryParams = queryParams.append('dataInicio', dataInicial);
    }

    if (dataFinal) {
      queryParams = queryParams.append('dataFim', dataFinal);
    }

    return this.http.get(`/apiconnect/importation/invoice`, {params: queryParams});
  }

  getFaturaEspecifica(idNotaFiscal: number, numeroSerieNF: string) {
    const url = `/apiconnect/importation/invoice/pdf/${idNotaFiscal}/invoice-id?codigoSerieNF=${numeroSerieNF}`;

    return this.http.get(url);
  }

  getRpsEspecifico(idNotaFiscal: number, numeroSerieNF: string) {
    const url = `/apiconnect/report/invoice-statements?codigoSerieNF=${numeroSerieNF}&idNotaFiscal=${idNotaFiscal}`;

    return this.http.get(url);

  }

}
